    <div class="v-container">
        <p-confirmDialog />
        <div class="overlay" *ngIf="isLoadingProjects">
            <p-progressSpinner styleClass="large-spinner"></p-progressSpinner>
        </div>

        <form [formGroup]="form">
            <!-- Placa de identidade do equipamento.
                 A ficha e um formulario que nasce desabilitado. Em LEITURA os
                 valores sao texto: campo vazio mostra travessao, nunca o
                 placeholder — era isso que fazia "Nota Fiscal" e "Data da
                 Compra" parecerem valores preenchidos. -->
            <div class="vcu-plate" [class.vcu-plate--editing]="editMode">
                <div class="vcu-plate__device">
                    <div class="vcu-plate__image"
                         [ngStyle]="{'background-image': formatImage(vcu.image?.href) }"></div>
                </div>

                <div class="vcu-plate__main">
                    <div class="vcu-plate__headline">
                        <input *ngIf="editMode"
                            type="text"
                            id="surname"
                            name="surname"
                            formControlName="surname"
                            maxlength="40"
                            placeholder="{{ 'vcu.surname' | transloco }}"
                            pInputText
                            class="vcu-plate__name-input" />
                        <h1 *ngIf="!editMode" class="vcu-plate__name">{{ readSurname }}</h1>

                        <span class="vcu-status-pill" [ngClass]="statusClass" *ngIf="statusName">
                            <i class="pi pi-circle-fill"></i>
                            {{ statusName }}
                        </span>

                        <!-- Acao principal no canto superior direito. Em edicao, o par
                             Cancelar/Salvar ocupa o MESMO lugar, para o olho nao ter
                             que procurar o controle em outro canto do cartao. -->
                        <div class="vcu-plate__quick-actions">
                            <ng-container *ngIf="!editMode">
                                <button type="button" class="action-btn primary"
                                        (click)="startEdit()" [disabled]="isDisabled">
                                    <i class="pi pi-pencil"></i>
                                    {{ 'vcu.header3' | transloco }}
                                </button>

                                <div class="btn-outline-wrapper danger" [class.disabled]="isPending || isDisabled">
                                    <div class="btn-outline-inner">
                                        <button type="button" class="action-btn outline-inner danger" (click)="deleteVcu()" [disabled]="isPending || isDisabled">
                                            <i class="pi pi-trash"></i>
                                            {{'vcu.header4' | transloco}}
                                        </button>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="editMode">
                                <div class="btn-outline-wrapper">
                                    <div class="btn-outline-inner">
                                        <button type="button" class="action-btn outline-inner" (click)="cancelEdit()">
                                            {{ 'common.buttons.cancel' | transloco }}
                                        </button>
                                    </div>
                                </div>
                                <button type="button" class="action-btn primary" (click)="saveEdit()">
                                    <i class="pi pi-check"></i>
                                    {{ 'common.buttons.save' | transloco }}
                                </button>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Serial: identidade do equipamento, em mono como na etiqueta.
                         Fica fora da edicao — e copiavel, nao editavel. -->
                    <div class="vcu-serial">
                        <span class="vcu-serial__label">{{ 'vcu.card.serial' | transloco }}</span>
                        <div class="vcu-serial__row">
                            <span class="vcu-serial__value">{{ vcu.serialNumber || '&#8212;' }}</span>
                            <button type="button" class="vcu-serial__copy"
                                    *ngIf="vcu.serialNumber"
                                    (click)="copySerial()"
                                    [pTooltip]="'messages.info.copied' | transloco"
                                    tooltipPosition="top">
                                <i class="pi pi-copy"></i>
                            </button>
                        </div>
                    </div>

                    <!-- O que o equipamento reporta: sempre leitura. -->
                    <div class="vcu-specs">
                        <div class="vcu-spec">
                            <span class="vcu-spec__label">{{ 'vcu.card.generalVersion' | transloco }}</span>
                            <span class="vcu-spec__value">{{ (vcu.generalVersionDate | dynamicDate: lang) || '&#8212;' }}</span>
                        </div>
                        <div class="vcu-spec">
                            <span class="vcu-spec__label">{{ 'vcu.card.lastAcess' | transloco }}</span>
                            <span class="vcu-spec__value">{{ (vcu.lastAcessDate | date: 'dd/MM/yyyy HH:mm') || '&#8212;' }}</span>
                        </div>
                    </div>

                    <!-- A ficha do usuario: texto na leitura, input na edicao. -->
                    <div class="vcu-fields">
                        <div class="vcu-field">
                            <span class="vcu-field__label">{{ 'vcu.family' | transloco }}</span>
                            <p-dropdown *ngIf="editMode" id="family"
                                [options]="familyOptions"
                                formControlName="family"
                                name="family"
                                optionLabel="name"
                                placeholder="{{ 'vcu.family' | transloco }}*"
                                emptyMessage="{{ 'noResult' | transloco }}"/>
                            <span *ngIf="!editMode" class="vcu-field__value"
                                  [class.vcu-field__value--empty]="!readFamily">{{ readFamily || '&#8212;' }}</span>
                        </div>

                        <div class="vcu-field">
                            <span class="vcu-field__label">{{ 'vcu.model' | transloco }}</span>
                            <p-dropdown *ngIf="editMode" id="model"
                                [options]="modelOptions"
                                formControlName="model"
                                name="model"
                                optionLabel="name"
                                placeholder="{{ 'vcu.model' | transloco }}*"
                                emptyMessage="{{ 'noResult' | transloco }}"/>
                            <span *ngIf="!editMode" class="vcu-field__value"
                                  [class.vcu-field__value--empty]="!readModel">{{ readModel || '&#8212;' }}</span>
                        </div>

                        <div class="vcu-field">
                            <span class="vcu-field__label">{{ 'vcu.invoice' | transloco }}</span>
                            <input *ngIf="editMode"
                                type="text"
                                id="invoice" name="invoice"
                                formControlName="invoice"
                                maxlength="40"
                                placeholder="{{ 'vcu.invoice' | transloco }}"
                                pInputText />
                            <span *ngIf="!editMode" class="vcu-field__value"
                                  [class.vcu-field__value--empty]="!readInvoice">{{ readInvoice || '&#8212;' }}</span>
                        </div>

                        <div class="vcu-field">
                            <span class="vcu-field__label">{{'vcu.detail.tableVcu.dateRegister' | transloco}}</span>
                            <p-calendar *ngIf="editMode && lang === 'pt-br'"
                                id="purchaseDate"
                                placeholder="{{ 'vcu.purchaseDate' | transloco }}"
                                formControlName="purchaseDate"
                                name="purchaseDate"
                                dateFormat="dd/mm/yy"
                                [showIcon]="true"
                                [showOnFocus]="false"
                                appendTo="body"/>
                            <p-calendar *ngIf="editMode && lang !== 'pt-br'"
                                id="purchaseDate"
                                placeholder="{{ 'vcu.purchaseDate' | transloco }}"
                                formControlName="purchaseDate"
                                name="purchaseDate"
                                dateFormat="mm/dd/yy"
                                [showIcon]="true"
                                [showOnFocus]="false"
                                appendTo="body"/>
                            <span *ngIf="!editMode" class="vcu-field__value"
                                  [class.vcu-field__value--empty]="!readPurchaseDate">{{ (readPurchaseDate | date: 'dd/MM/yyyy') || '&#8212;' }}</span>
                        </div>

                        <div class="vcu-field vcu-field--full">
                            <span class="vcu-field__label">Tags</span>
                            <p-chips *ngIf="editMode"
                                id="tags"
                                name="tags"
                                placeholder="{{ 'vcu.tags' | transloco }}"
                                formControlName="tags"
                                separator="," />
                            <div *ngIf="!editMode" class="vcu-tag-list">
                                <span class="vcu-tag" *ngFor="let tag of readTags">#{{ tag }}</span>
                                <span class="vcu-field__value vcu-field__value--empty"
                                      *ngIf="readTags.length === 0">&#8212;</span>
                            </div>
                        </div>
                    </div>

                    <!-- Telemetria desativada a pedido: nao sera usada por enquanto.
                         Fica comentada (nao removida) porque o fluxo volta depois —
                         onTelemetryClick(), hasTelemetry e o modal Pro seguem no lugar.
                    <button type="button" class="action-btn primary" (click)="onTelemetryClick()" [disabled]="!vcu.serialNumber">
                        <i class="pi pi-chart-line"></i>
                        Telemetria
                        <i *ngIf="!hasTelemetry" class="pi pi-crown plan-pro-icon"></i>
                    </button>
                    -->
                </div>
            </div>

            <app-pro-feature-modal
                [(visible)]="showProModal"
                featureName="Telemetria"
                [currentPlanId]="currentPlanId"
                [billingType]="billingType"
                (planUpgraded)="onPlanUpgraded()">
            </app-pro-feature-modal>
        </form>

        <!-- Projects -->
        <div class="content-section">
            <div class="section-header-modern">
                <div class="section-title-row">
                    <i class="pi pi-folder section-icon"></i>
                    <h2 class="section-title">{{ 'vcu.detail.project' | transloco }}</h2>
                </div>
                <div class="section-toolbar">
                    <button class="action-btn primary compact" (click)="linkToProject()">
                        <i class="pi pi-link"></i>
                        {{ 'vcu.detail.tabProject.link' | transloco }}
                    </button>
                    <div class="btn-outline-wrapper compact">
                        <div class="btn-outline-inner">
                            <button class="action-btn outline-inner compact" (click)="newProject()">
                                <i class="pi pi-plus"></i>
                                {{ 'vcu.detail.tabProject.new' | transloco }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="projects-grid" *ngIf="!isLoadingProjects && vcu.projects?.length">
                <div class="grid-item" *ngFor="let project of vcu.projects">
                    <app-card-project [project]="project" [user]="userID" (refreshDashboard)="refreshListProjects()"></app-card-project>
                </div>
            </div>
            <div class="vcu-empty" *ngIf="!isLoadingProjects && !vcu.projects?.length">
                <i class="pi pi-folder-open vcu-empty__icon"></i>
                <p class="vcu-empty__title">{{ 'vcu.detail.noProjects' | transloco }}</p>
                <p class="vcu-empty__desc">{{ 'vcu.detail.noProjectsHint' | transloco }}</p>
            </div>
        </div>

        <!-- Maps -->
        <div class="content-section">
            <div class="section-header-modern">
                <div class="section-title-row">
                    <i class="pi pi-map section-icon"></i>
                    <h2 class="section-title">{{ 'project.detail.map' | transloco }}</h2>
                </div>
                <div class="section-toolbar">
                    <div class="search-box">
                        <i class="pi pi-search search-box-icon"></i>
                        <input type="text" (input)="applyFilterGlobalMap($event, 'contains')"
                            placeholder="{{ 'project.detail.tableMap.search' | transloco }}" />
                    </div>
                </div>
            </div>
            <p-table #dtMap [value]="maps" dataKey="id" [rows]="5" [loading]="loadingMap"
                [paginator]="true" [showCurrentPageReport]="true"
                currentPageReportTemplate="{{ 'project.detail.tableMap.currentPage' | transloco }}"
                [globalFilterFields]="['fileName', 'createdDate']">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="fileName" style="width:45%">
                            {{ 'project.detail.tableMap.name' | transloco }} <p-sortIcon field="fileName" />
                        </th>
                        <th pSortableColumn="createdDate" style="width:30%">
                            {{ 'project.detail.tableMap.date' | transloco }} <p-sortIcon field="createdDate" />
                        </th>
                        <th style="width:25%">{{ 'project.detail.tableMap.action' | transloco }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-map let-ri="rowIndex">
                    <tr>
                        <td>{{ map.fileName || '-' }}</td>
                        <td>{{ map.createdDate || '-' }}</td>
                        <td>
                            <p-button [rounded]="true" [text]="true" icon="pi pi-download" (click)="onRowDownload('map', ri)" />
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr><td colspan="3">{{ 'project.detail.tableMap.noFound' | transloco }}</td></tr>
                </ng-template>
            </p-table>
        </div>

        <!-- VCU Logs -->
        <div class="content-section">
            <div class="section-header-modern">
                <div class="section-title-row">
                    <i class="pi pi-file section-icon"></i>
                    <h2 class="section-title">{{ 'project.detail.log' | transloco }}</h2>
                </div>
                <div class="section-toolbar">
                    <div class="search-box">
                        <i class="pi pi-search search-box-icon"></i>
                        <input type="text" (input)="applyFilterGlobalLog($event, 'contains')"
                            placeholder="{{ 'project.detail.tableLog.search' | transloco }}" />
                    </div>
                </div>
            </div>
            <p-table #dtLog [value]="logs" dataKey="id" [rows]="5" [loading]="loadingLog"
                [paginator]="true" [showCurrentPageReport]="true"
                currentPageReportTemplate="{{ 'project.detail.tableLog.currentPage' | transloco }}"
                [globalFilterFields]="['fileName', 'createdDate']">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="fileName" style="width:45%">
                            {{ 'project.detail.tableLog.name' | transloco }} <p-sortIcon field="fileName" />
                        </th>
                        <th pSortableColumn="createdDate" style="width:30%">
                            {{ 'project.detail.tableLog.date' | transloco }} <p-sortIcon field="createdDate" />
                        </th>
                        <th style="width:25%">{{ 'project.detail.tableLog.action' | transloco }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-log let-ri="rowIndex">
                    <tr>
                        <td>{{ log.fileName || '-' }}</td>
                        <td>{{ log.createdDate || '-' }}</td>
                        <td>
                            <p-button [rounded]="true" [text]="true" icon="pi pi-download" (click)="onRowDownload('log', ri)" />
                            <p-button [rounded]="true" [text]="true" icon="pi pi-trash" (click)="onRowRemoveLog($event, ri)" />
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr><td colspan="3">{{ 'project.detail.tableLog.noFound' | transloco }}</td></tr>
                </ng-template>
            </p-table>
        </div>

        <!-- Documentation -->
        <div class="content-section">
            <div class="section-header-modern">
                <div class="section-title-row">
                    <i class="pi pi-book section-icon"></i>
                    <h2 class="section-title">{{ 'vcu.detail.doc.title' | transloco }}</h2>
                </div>
            </div>
            <div class="docs-grid">
                <div class="doc-card">
                    <div class="doc-card-info">
                        <i class="pi pi-file-pdf doc-icon"></i>
                        <div class="doc-meta">
                            <span class="doc-name">Manual FT450 / FT550 LITE / FT550 / FT600</span>
                            <span class="doc-detail">{{ 'vcu.detail.doc.version' | transloco }} 4.4 &bull; 30 MB</span>
                        </div>
                    </div>
                    <button class="doc-download-btn">
                        <i class="pi pi-download"></i>
                    </button>
                </div>
                <div class="doc-card">
                    <div class="doc-card-info">
                        <i class="pi pi-file-pdf doc-icon"></i>
                        <div class="doc-meta">
                            <span class="doc-name">Manual FT700 / FT700 PLUS</span>
                            <span class="doc-detail">{{ 'vcu.detail.doc.version' | transloco }} 4.4 &bull; 30 MB</span>
                        </div>
                    </div>
                    <button class="doc-download-btn">
                        <i class="pi pi-download"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <p-dialog header="{{ 'vcu.detail.unlinkVcu.header' | transloco }}" [modal]="true" [(visible)]="showDialogUnlink" [style]="{ width: '25rem' }">
        <span class="dialog-msg">{{ 'vcu.detail.unlinkVcu.msg' | transloco }}</span>
        <div class="v-row">
            <textarea
              id="projectLink"
              name="projectLink"
              rows="3"
              cols="20"
              maxlength="500"
              placeholder="{{ 'vcu.detail.unlinkVcu.reason' | transloco }}"
              [(ngModel)]="reasonUnlinkVcu"
              [ngClass]="projectUnlinkInvalid"
              (onChange)="projectUnlinkInvalid = ''"
              pInputTextarea
              [style]="{'width':'100%', 'margin-bottom':'30px'}" >
            </textarea>
        </div>
        <div class="v-row">
            <p-messages id="messages"
                [(value)]="messages"
                [enableService]="false"
                [style]="{'font-size':'15px'}"/>
        </div>
        <div class="dialog-btns">
            <p-button id="dialog-cancel" label="{{ 'vcu.detail.unlinkVcu.cancel' | transloco }}" severity="secondary" (onClick)="showDialogUnlink = false" />
            <p-button id="dialog-save" label="{{ 'vcu.detail.unlinkVcu.save' | transloco }}" [loading]="unlinkVcuBtnLoading" (onClick)="unlinkVCU()" />
        </div>
    </p-dialog>

    <p-dialog
        id="linkVcu"
        header="{{ 'vcu.detail.linkVcu.header' | transloco }}"
        [modal]="true"
        [(visible)]="showDialogLink"
        [style]="{ 'width': '620px', 'max-width': '95vw' }">
        <span class="link-dialog-subtitle">{{ 'vcu.detail.linkVcu.msg' | transloco }}:</span>

        <div class="link-projects-grid" *ngIf="availableProjects.length > 0">
            <div class="link-project-card"
                 *ngFor="let proj of availableProjects"
                 [class.selected]="selectedProjectId === proj.id"
                 (click)="selectProjectCard(proj)">
                <div class="link-card-image"
                     [ngStyle]="{'background-image': getProjectCardImage(proj) }">
                    <div class="link-card-check" *ngIf="selectedProjectId === proj.id">
                        <i class="pi pi-check"></i>
                    </div>
                </div>
                <div class="link-card-info">
                    <span class="link-card-name">{{ proj.name }}</span>
                    <div class="link-card-tags" *ngIf="proj.tags && proj.tags.length > 0">
                        <span class="link-card-tag" *ngFor="let tag of proj.tags | slice:0:2">#{{ tag }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="link-empty" *ngIf="availableProjects.length === 0">
            <i class="pi pi-inbox"></i>
            <span>{{ 'noResult' | transloco }}</span>
        </div>

        <div class="link-dialog-footer" [class.has-error]="projectLinkInvalid">
            <span class="link-error-msg" *ngIf="projectLinkInvalid">{{ 'vcu.detail.linkVcu.project' | transloco }}</span>
            <div class="link-dialog-actions">
                <div class="btn-outline-wrapper compact">
                    <div class="btn-outline-inner">
                        <button class="action-btn outline-inner compact" (click)="showDialogLink = false">
                            {{ 'vcu.detail.linkVcu.cancel' | transloco }}
                        </button>
                    </div>
                </div>
                <button class="action-btn primary compact" (click)="linkVCU()" [disabled]="!selectedProjectId">
                    {{ 'vcu.detail.linkVcu.save' | transloco }}
                </button>
            </div>
        </div>
    </p-dialog>

    <p-toast key="toastVcu" />
    <app-register-project [showDialog]="showProjectDialog" (closeDialog)="updateProjectDialog($event)"></app-register-project>

